import * as React from "react";
import Card from "@mui/material/Card";
// import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
// import Button from "@mui/material/Button";
// import Typography from "@mui/material/Typography";
import "./MediaCard.css";
import { useSelector } from "react-redux";
import { fetchCurrentState } from "../../../../redux/features/customerViewSlice";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation, Virtual } from "swiper";
import { v4 } from "uuid";
import { useNavigate } from "react-router-dom";
import {
  ChipTitle,
  dateDDMM,
  dateRangeFormat,
  onlySpaces,
} from "../../../../util";
import guest from "../../../../assets/images/guest.svg";
// import getCurrencySymbol from 'currency-symbol-map'
// import { bookingStatusWrapper } from '../../../../util'
import { mediaViewModel, stayViewModel } from "../../customerViewDataModel";
import calender_icon from "../../../../assets/images/icons/calender_icon.svg";
// import booking_icon from '../../../../assets/images/icons/booking_icon.svg'
import SwiperButtonNext from "../../../common/swiperNextSlide";
import SwiperButtonPrev from "../../../common/swiperPrevSlide";
import { isEmpty } from "lodash";
import leftArrow from "../../../../assets/images/icons/media-left-arrow.svg";
import rightArrow from "../../../../assets/images/icons/media-right-arrow.svg";
import muteIcon from "../../../../assets/images/icons/mute-icon.svg";
import unmuteIcon from "../../../../assets/images/icons/unmute-icon.svg";
import ChipTag from "../../../common/ChipTag";
import TextTruncate from "react-text-truncate";
import leisureDayBig from "../../../../assets/images/leisure-day-big-grey.svg";
import { useMemo } from "react";
import confirmed_icon from "../../../../assets/images/icons/confirmed_icon.svg";
import { useRef } from "react";
import { useEffect } from "react";
import {
  analyticsEvent,
  eventName,
} from "../../../common/Analytics/AnalyticsEvent";
import { NumericFormat } from "react-number-format";
import { useState } from "react";
import useElementOnScreen from "../../../common/customHooks/useElementOnScreen";

export default function MediaSlides({
  element,
  handleDetailPageOpen,
  stayDates,
  stayDay,
  setisMediaMuted,
  isMediaMuted,
  detailPageState,
}) {
  // console.log('MediaSlides>>>:: Element', element)
  // const [isMediaMuted, setisMediaMuted] = useState(true)
  const [isVideoPlaying, setisVideoPlaying] = useState(false);

  const videoRef = useRef(null);
  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.7,
  };
  const isVisibile = useElementOnScreen(options, videoRef);

  let [dialogCounter, setdialogCounter] = useState(0);

  useEffect(() => {
    // window.addEventListener("resize", handleResize)
    localStorage.setItem("mediaMuteState", true);
    if (isVisibile) {
      if (!isVideoPlaying) {
        const promise = videoRef.current.play();
        // console.log(videoRef)
        promise
          .then(() => {
            setisVideoPlaying(true);
          })
          .catch((error) => {
            setisVideoPlaying(false);
          });
      }
    } else {
      if (isVideoPlaying) {
        // videoRef.current.pause();
        videoRef.current.pause();
        setisVideoPlaying(false);
      }
    }
    if (!detailPageState && dialogCounter !== 0) {
      console.log(">>>>dialogCounter", dialogCounter);
      console.log(">>>>media mute state", isMediaMuted);
      // setisMediaMuted(false)
      videoRef.current.play();
      setdialogCounter(0);
      localStorage.setItem("mediaMuteState", isMediaMuted);
    }
  }, [isVisibile, detailPageState]);

  // const onVideoClick = () => {
  //   // console.log(isVideoPlaying)
  //   // if (isVideoPlaying) {
  //   //   videoRef.current.pause()
  //   //   setisVideoPlaying(!isVideoPlaying)
  //   // } else {
  //   //   videoRef.current.play()
  //   //   setisVideoPlaying(!isVideoPlaying)
  //   // }
  //   if (props.isMediaMuted) {
  //     props.setisMediaMuted(false)
  //   } else {
  //     props.setisMediaMuted(true)
  //   }
  // }

  const mediaMuteHandle = () => {
    if (isMediaMuted) {
      setisMediaMuted(false);
      console.log(">>>>dialogCounter", dialogCounter);
      localStorage.setItem("mediaMuteState", false);
    } else {
      setisMediaMuted(true);
      console.log(">>>>dialogCounter", dialogCounter);
      localStorage.setItem("mediaMuteState", true);
    }
  };

  return (
    <div>
      <Card
        sx={{
          maxWidth: "100%",
          margin: "auto",
          borderRadius: "8px 8px 8px 8px",
          cursor: "pointer",
          border: "none",
          boxShadow: "2px 4px 24px rgba(11, 12, 21, 0.1)",
        }}
        variant="outlined"
        // onClick={() => {
        //   navigate('detail-page', {
        //     state: { item_id: element.item_id },
        //   })
        // }}
      >
        {isEmpty(element.video) ? (
          <CardMedia
            component="img"
            alt="media-pics"
            // height="250"

            image={element.image}
            // src={element.video.src}
            sx={{
              borderRadius: "8px 8px 0px 0px",
              position: "relative",
            }}
            className="media-image-slide"
            onClick={() => {
              handleDetailPageOpen(element.item_id, element.is_default);
              analyticsEvent.clickEvent(
                "Media",
                eventName.Media_view_item_details,
                `item_id: ${element.item_id}, item_type: ${element.item_type}, item_name: ${element.place_title}, item_city: ${element.city}`
              );
            }}
          />
        ) : (
          <>
            <CardMedia
              component="video"
              alt="media-pics"
              height="250"
              ref={videoRef}
              // onClick={mediaMuteHandle}
              onClick={() => {
                handleDetailPageOpen(element.item_id, element.is_default);
                analyticsEvent.clickEvent(
                  "Media",
                  eventName.Media_view_item_details,
                  `item_id: ${element.item_id}, item_type: ${element.item_type}, item_name: ${element.place_title}, item_city: ${element.city}`
                );
                if (!isEmpty(element.video)) {
                  // setisMediaMuted(true)
                  localStorage.setItem("mediaMuteState", isMediaMuted);
                  videoRef.current.pause();
                  if (isVideoPlaying) {
                    setdialogCounter(1);
                  }
                }
              }}
              // image={element.image}
              src={element.video.src}
              sx={{
                borderRadius: "8px 8px 0px 0px",
                position: "relative",
              }}
              style={{ objectFit: "cover" }}
              className="media-image-slide dynamic-height-media"
              muted={isMediaMuted}
              poster={element.video.thumbnail}
              loop
              playsInline
            />
            <img
              src={isMediaMuted ? muteIcon : unmuteIcon}
              alt="mute-icon"
              // className={!isMediaMuted && 'fade-out-icon'}
              onClick={mediaMuteHandle}
              style={
                // isMediaMuted
                // ?
                {
                  position: "absolute",
                  // bottom: '103px',
                  top: "22px",
                  transform: "translate(-50%, -44%)",
                  zIndex: "100",
                  width: "40px",
                  height: "auto",
                  cursor: "pointer",
                  padding: "30px",
                  right: "-70px",
                }
                // : { display: 'none' }
              }
            ></img>
          </>
        )}
        <div
          style={{
            position: "absolute",
            left: "10px",
            top: "15px",
            zIndex: 2,
          }}
        >
          <ChipTag
            tagInfo={{
              label:
                element.item_type === "HOTEL"
                  ? ChipTitle[element.item_type] + " " + element.stayCounter
                  : ChipTitle[element.item_type] + " " + element.stopCounter,

              bgColor: "white",
              item_type: element.item_type,
            }}
          />
        </div>
        <CardContent
          style={{
            lineHeight: "10px",
            height: "105px",
            padding: "0px 15px 10px 15px",
            textAlign: "left",
            borderRadius: "0px 0px 8px 8px",
          }}
          onClick={() => {
            handleDetailPageOpen(element.item_id, element.is_default);
            analyticsEvent.clickEvent(
              "Media",
              eventName.Media_view_item_details,
              `item_id: ${element.item_id}, item_type: ${element.item_type}, item_name: ${element.place_title}, item_city: ${element.city}`
            );
            if (!isEmpty(element.video)) {
              // setisMediaMuted(true)
              // console.log('>>>>media mute state', isMediaMuted)
              localStorage.setItem("mediaMuteState", isMediaMuted);
              videoRef.current.pause();
              if (isVideoPlaying) {
                setdialogCounter(1);
              }
            }
          }}
        >
          <div>
            {/* Booking Status */}
            {element.booking_status === "BOOKING_CONFIRMED" && (
              <div
                style={{
                  marginTop: "5px",
                }}
              >
                <p
                  className="body3"
                  style={{
                    color: "var(--statusSeaweedGreen)",
                  }}
                >
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={confirmed_icon}
                      style={{
                        marginRight: "3px",
                        width: "20px",
                        height: "20px",
                      }}
                      alt="confirmed"
                    ></img>
                    Booking Confirmed
                  </span>
                </p>
              </div>
            )}
            {/* Booking Status end */}
            {element.item_type === "ACTIVITY" && (
              <TextTruncate
                line={2}
                element="p"
                truncateText="…"
                text={element.place_title}
                containerClassName="headline2"
                style={{
                  color: "var(--gray100)",
                  lineHeight: "22.5px",
                }}
              />
            )}
            {element.item_type !== "ACTIVITY" && (
              <p
                className="headline2 truncated"
                style={{
                  color: "var(--gray100)",
                  lineHeight: "22.5px",
                }}
              >
                {element.place_title}
              </p>
            )}
            {/* </p> */}
            <p
              className="body3"
              style={{
                color: "var(--gray80)",
                lineHeight: "115%",
              }}
            >
              {element.rating && (
                <>
                  <span
                    style={
                      element.item_type !== "HOTEL"
                        ? {
                            color: "var(--statusSeaweedGreen)",
                          }
                        : {}
                    }
                  >
                    {element.item_type !== "HOTEL" && <span>&#9733;</span>}{" "}
                    {element.rating}
                  </span>
                  <span> &#x2022;&nbsp;</span>
                </>
              )}
              <span>
                {element.item_type === "HOTEL" && (
                  <span>
                    {stayDates.length > 1
                      ? !isEmpty(stayDates[0]) &&
                        !isEmpty(stayDates[stayDates.length - 1])
                        ? dateRangeFormat(
                            stayDates[0],
                            stayDates[stayDates.length - 1]
                          )
                        : "Day: " +
                          stayDay[0] +
                          "-" +
                          stayDay[stayDay.length - 1]
                      : !isEmpty(stayDates[0])
                      ? dateDDMM(stayDates[0])
                      : "Day: " + stayDay[0]}
                  </span>
                )}
                {/* {element.item_type === 'ACTIVITY' && (
                  <span> &#x2022;&nbsp;</span>
                )} */}
                {element.item_type !== "HOTEL" && element.activity_name && (
                  <span>{element.activity_name}</span>
                )}
                {element.duration && (
                  <span> &#x2022;&nbsp;{element.duration}</span>
                )}
              </span>

              {element.total_guest && (
                <span>
                  {" "}
                  &#x2022;&nbsp;
                  <img
                    src={guest}
                    style={{
                      width: "12px",
                      height: "auto",
                      display: "inline",
                    }}
                    alt="guest"
                  ></img>{" "}
                  {element.total_guest}
                </span>
              )}
              {element.price &&
                element.booking_status !== "BOOKING_CONFIRMED" &&
                element.item_type === "HOTEL" && (
                  <span>
                    {" "}
                    &#x2022;&nbsp;
                    {"from "}
                    <NumericFormat
                      value={element.price}
                      thousandsGroupStyle="lakh"
                      thousandSeparator=","
                      displayType="text"
                      renderText={(value) => (
                        <span>{element.currency + value}</span>
                      )}
                    />
                  </span>
                )}
              {element.price &&
                element.booking_status === "BOOKING_CONFIRMED" &&
                element.item_type === "HOTEL" && (
                  <span>
                    {" "}
                    &#x2022;
                    {/* {element.price} */}
                    <NumericFormat
                      value={element.price}
                      thousandsGroupStyle="lakh"
                      thousandSeparator=","
                      displayType="text"
                      renderText={(value) => (
                        <span>{element.currency + value}</span>
                      )}
                    />
                  </span>
                )}
              {element.price && element.item_type === "ACTIVITY" && (
                <>
                  <span> &#x2022; </span>
                  <NumericFormat
                    value={element.price}
                    thousandsGroupStyle="lakh"
                    thousandSeparator=","
                    displayType="text"
                    renderText={(value) => (
                      <span>{element.currency + value}</span>
                    )}
                  />
                </>
              )}
            </p>
            {!isEmpty(element.description) &&
              !onlySpaces(element.description) && (
                // <p
                //   className="body3"

                // >
                <TextTruncate
                  line={2}
                  element="p"
                  truncateText="…"
                  text={element.description}
                  containerClassName="body3 description-height"
                  style={{
                    color: "var(--gray80)",
                    lineHeight: "22.5px",
                  }}
                />
                // </p>
              )}
            {/* {element.booking_status !== 'BOOKING_CONFIRMED' &&
              (element.item_type === 'ACTIVITY' ||
                element.item_type === 'HOTEL') && (
                <p className="headline2" style={{ marginTop: '14px' }}>
                  <span className="body3" style={{ color: 'var(--gray80)' }}>
                    from {element.price}
                  </span>
                </p>
              )} */}
          </div>
        </CardContent>
      </Card>
      <div style={{ height: "40px" }}></div>
    </div>
  );
}
